import { render, staticRenderFns } from "./IframeSideNav.vue?vue&type=template&id=bd39d788&"
import script from "./IframeSideNav.vue?vue&type=script&lang=js&"
export * from "./IframeSideNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports